import React, { Component } from 'react';
import './index.scss';

import bgImg from '../../../assets/product-interaction/ddsu5168/ddsu5168_background.png';
import logoImg from '../../../assets/product-interaction/ddsu5168/ddsu5168_logo_white.png';
import productImg from '../../../assets/product-interaction/ddsu5168/ddsu5168_2p_product.png';
import qrImg from '../../../assets/product-interaction/ddsu5168/ddsu5168_qr_code.jpg';

class ElecDDSU5168Next extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      scale: 1
    };
  }

  componentDidMount() {
    document.title = 'DDSU5168｜单相电子式电能表（2P）';
    this.fitPage();
    window.addEventListener('resize', this.fitPage);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.fitPage);
  }

  fitPage = () => {
    const scale = Math.min(window.innerWidth / 1080, window.innerHeight / 1920, 1);
    this.setState({ scale });
  };

  render() {
    const { scale } = this.state;

    return (
      <div className="ddsu5168-interactive-wrapper">
        <div 
          id="viewport" 
          style={{ 
            width: `${1080 * scale}px`, 
            height: `${1920 * scale}px` 
          }}
        >
          <main 
            className="page" 
            id="page" 
            style={{ 
              transform: `scale(${scale})` 
            }}
          >
            {bgImg && <img className="background" src={bgImg} alt="产品服务页面背景" />}
            {logoImg && <img className="logo" src={logoImg} alt="源一物联" />}

            <section className="copy">
              <div className="model-top">DDSU5168</div>
              <h1>单相电子式电能表（2P）</h1>
              <div className="slogan">蓝牙通讯 · 便捷安装</div>
              <div className="tags">
                <div className="tag">RS485</div>
                <div className="tag">4G</div>
                <div className="tag">LoRa</div>
              </div>
            </section>

            <section className="product-zone">
              <img className="product" src={productImg} alt="DDSU5168 单相电子式电能表" />
            </section>

            <footer className="footer">
              <div className="footer-top">
                <div className="support">
                  <strong>说明书与安装服务</strong>
                  <span>点击下方入口，快速查看对应资料</span>
                </div>
                <div className="qr-wrap">
                  {qrImg && <img className="qr" src={qrImg} alt="源一物联公众号二维码" />}
                </div>
              </div>

              <div className="actions">
                <a 
                  className="action" 
                  href="http://m.joymeter.com/manual?code=DDSU5168-700-006" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  title="打开 DDSU5168 使用说明"
                >
                  <div className="icon">
                    <svg viewBox="0 0 24 24">
                      <path d="M6 3h9l3 3v15H6z" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M15 3v4h4M9 11h6M9 15h6" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </div>
                  <div>
                    <b>查看使用说明</b>
                    <span>USER GUIDE · 点击打开 ↗</span>
                  </div>
                </a>

                <a 
                  className="action" 
                  href="/product/ddsu5168/wiring"
                  title="查看 DDSU5168 接线图"
                >
                  <div className="icon">
                    <svg viewBox="0 0 24 24">
                      <path d="M12 3 2.8 20h18.4z" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M12 9v5M12 17.5v.2" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </div>
                  <div>
                    <b>查看接线图</b>
                    <span>WIRING GUIDE · 点击查看 →</span>
                  </div>
                </a>
              </div>
            </footer>
          </main>
        </div>
      </div>
    );
  }
}

export default ElecDDSU5168Next;
